import {createStore} from "redux";

export const configureStore = () => createStore(state => state, [])